// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nu-menu .md-button{color:#5c7e99}.nu-menu .md-button[disabled]{color:#cfdbe6}`, "",{"version":3,"sources":["webpack://./src/shared/components/nu-menu/menu.scss","webpack://./src/scss/style-dictionary.scss"],"names":[],"mappings":"AAGI,oBACI,aCiBa,CDfb,8BACI,aCgBU","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
